import {
  draughtPriceFilterType,
  packagedPriceFilterType,
  PriceType,
} from "./FilterPriceTypes";

export type PriceTypeCategory = "packaged" | "draught";

export function getPriceTypeCategory(selectedContainerTypes: any[]) {
  if (selectedContainerTypes.length === 0) return;
  if (
    selectedContainerTypes.includes("keg") ||
    selectedContainerTypes.includes("cask")
  )
    return "draught";
  return "packaged";
}

export const getPriceTypeCategoryFromPrice = (selectedPriceType: PriceType) => {
  if (selectedPriceType in packagedPriceFilterType) return "packaged";
  if (selectedPriceType in draughtPriceFilterType) return "draught";
};
